import { render, staticRenderFns } from "./OrganizationFeatured.vue?vue&type=template&id=171ea5d3&scoped=true&"
import script from "./OrganizationFeatured.vue?vue&type=script&lang=js&"
export * from "./OrganizationFeatured.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationFeatured.vue?vue&type=style&index=0&id=171ea5d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ea5d3",
  null
  
)

export default component.exports